import { render } from "./FormGiveCoupon.vue?vue&type=template&id=d51cbdc6&ts=true"
import script from "./FormGiveCoupon.vue?vue&type=script&lang=ts"
export * from "./FormGiveCoupon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__